var map = {
	"./AGoodNewsStoryFromPeddie": [
		359,
		58
	],
	"./AGoodNewsStoryFromPeddie.js": [
		359,
		58
	],
	"./AdviceFromTheExpertsPart10": [
		367,
		59
	],
	"./AdviceFromTheExpertsPart10.js": [
		367,
		59
	],
	"./AdviceFromTheExpertsPart11": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart11.js": [
		368,
		60
	],
	"./AdviceFromTheExpertsPart5": [
		281,
		49
	],
	"./AdviceFromTheExpertsPart5.js": [
		281,
		49
	],
	"./AdviceFromTheExpertsPart6": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart6.js": [
		369,
		61
	],
	"./AdviceFromTheExpertsPart7": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart7.js": [
		370,
		62
	],
	"./AdviceFromTheExpertsPart8": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart8.js": [
		371,
		63
	],
	"./AdviceFromTheExpertsPart9": [
		372,
		64
	],
	"./AdviceFromTheExpertsPart9.js": [
		372,
		64
	],
	"./AdviceFromTheExpertsTenantsPart1": [
		282,
		50
	],
	"./AdviceFromTheExpertsTenantsPart1.js": [
		282,
		50
	],
	"./AdviceFromTheExpertsTenantsPart2": [
		283,
		51
	],
	"./AdviceFromTheExpertsTenantsPart2.js": [
		283,
		51
	],
	"./AlternativeEnergyInstallations": [
		361,
		65
	],
	"./AlternativeEnergyInstallations.js": [
		361,
		65
	],
	"./AreGardensOwnedByUnitOwners": [
		284,
		66
	],
	"./AreGardensOwnedByUnitOwners.js": [
		284,
		66
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair": [
		285,
		67
	],
	"./BlockedSeweragePipesWhoIsResponsibleForMaintenaceAndRepair.js": [
		285,
		67
	],
	"./CIAGeyserEmergencyAssist": [
		362,
		68
	],
	"./CIAGeyserEmergencyAssist.js": [
		362,
		68
	],
	"./CIAPrivacyPolicy": [
		373,
		14
	],
	"./CIAPrivacyPolicy.js": [
		373,
		14
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers": [
		286,
		69
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembers.js": [
		286,
		69
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2": [
		287,
		70
	],
	"./CanTrusteesDisconnectServicesFromNonPayingMembersPart2.js": [
		287,
		70
	],
	"./CiaIssuesPolicy": [
		288,
		52
	],
	"./CiaIssuesPolicy.js": [
		288,
		52
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining": [
		374,
		71
	],
	"./CiaLaunchesOnlineFidelityComputerCrimeTraining.js": [
		374,
		71
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount": [
		289,
		53
	],
	"./ClaimsPaymentsAndWhyItIsPreferableToPayDirectlyIntoTheBodyCorporateOrManagingAgentsTrustAccount.js": [
		289,
		53
	],
	"./CommonPropertyPart1": [
		375,
		72
	],
	"./CommonPropertyPart1.js": [
		375,
		72
	],
	"./CommonPropertyPart2": [
		376,
		73
	],
	"./CommonPropertyPart2.js": [
		376,
		73
	],
	"./CommonPropertyPart3": [
		377,
		74
	],
	"./CommonPropertyPart3.js": [
		377,
		74
	],
	"./CommonPropertyPart4": [
		378,
		75
	],
	"./CommonPropertyPart4.js": [
		378,
		75
	],
	"./CommonPropertyPart5": [
		379,
		76
	],
	"./CommonPropertyPart5.js": [
		379,
		76
	],
	"./CommunitySchemesTraining": [
		380,
		77
	],
	"./CommunitySchemesTraining.js": [
		380,
		77
	],
	"./ComputeCrimeClaimsPart2": [
		290,
		78
	],
	"./ComputeCrimeClaimsPart2.js": [
		290,
		78
	],
	"./ComputeCrimeClaimsPart3": [
		291,
		79
	],
	"./ComputeCrimeClaimsPart3.js": [
		291,
		79
	],
	"./ComputerCrimePolicyWordingChanges": [
		292,
		80
	],
	"./ComputerCrimePolicyWordingChanges.js": [
		292,
		80
	],
	"./ComputerCrimePolicyWordingChanges1": [
		381,
		81
	],
	"./ComputerCrimePolicyWordingChanges1.js": [
		381,
		81
	],
	"./ComputerCrimeWordingProposalFormPart1": [
		293,
		82
	],
	"./ComputerCrimeWordingProposalFormPart1.js": [
		293,
		82
	],
	"./DealingWithABodyCorporateClaim": [
		294,
		83
	],
	"./DealingWithABodyCorporateClaim.js": [
		294,
		83
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection": [
		295,
		84
	],
	"./DefectiveDesignOrConstructionCanCauseClaimsRejection.js": [
		295,
		84
	],
	"./DidYouKnowPart1": [
		382,
		85
	],
	"./DidYouKnowPart1.js": [
		382,
		85
	],
	"./DidYouKnowPart2": [
		296,
		54
	],
	"./DidYouKnowPart2.js": [
		296,
		54
	],
	"./DidYouKnowPart3": [
		297,
		55
	],
	"./DidYouKnowPart3.js": [
		297,
		55
	],
	"./DidYouKnowPart4": [
		383,
		6
	],
	"./DidYouKnowPart4.js": [
		383,
		6
	],
	"./DidYouKnowPart5": [
		384,
		7
	],
	"./DidYouKnowPart5.js": [
		384,
		7
	],
	"./DidYouKnowPart6": [
		385,
		8
	],
	"./DidYouKnowPart6.js": [
		385,
		8
	],
	"./EmployersLiability": [
		298,
		86
	],
	"./EmployersLiability.js": [
		298,
		86
	],
	"./EnforcementOfRulesPart1": [
		386,
		15
	],
	"./EnforcementOfRulesPart1.js": [
		386,
		15
	],
	"./EnforcementOfRulesPart2": [
		387,
		16
	],
	"./EnforcementOfRulesPart2.js": [
		387,
		16
	],
	"./EnforcementOfRulesPart4": [
		388,
		17
	],
	"./EnforcementOfRulesPart4.js": [
		388,
		17
	],
	"./EnforecmentOfRulesPart3": [
		389,
		18
	],
	"./EnforecmentOfRulesPart3.js": [
		389,
		18
	],
	"./EnvironmentalUpgradeForGeysers": [
		299,
		87
	],
	"./EnvironmentalUpgradeForGeysers.js": [
		299,
		87
	],
	"./ExamplesOfCxtraCoverFollowingDamage": [
		300,
		88
	],
	"./ExamplesOfCxtraCoverFollowingDamage.js": [
		300,
		88
	],
	"./FidelityFundCertificatesAndCreditChecks": [
		301,
		89
	],
	"./FidelityFundCertificatesAndCreditChecks.js": [
		301,
		89
	],
	"./FireRiskManagementTipsProtectionAgainstFire": [
		302,
		90
	],
	"./FireRiskManagementTipsProtectionAgainstFire.js": [
		302,
		90
	],
	"./FireWisePart1": [
		390,
		91
	],
	"./FireWisePart1.js": [
		390,
		91
	],
	"./FireWisePart10": [
		391,
		92
	],
	"./FireWisePart10.js": [
		391,
		92
	],
	"./FireWisePart11": [
		392,
		93
	],
	"./FireWisePart11.js": [
		392,
		93
	],
	"./FireWisePart12": [
		363,
		94
	],
	"./FireWisePart12.js": [
		363,
		94
	],
	"./FireWisePart13": [
		303,
		95
	],
	"./FireWisePart13.js": [
		303,
		95
	],
	"./FireWisePart14": [
		304,
		96
	],
	"./FireWisePart14.js": [
		304,
		96
	],
	"./FireWisePart15": [
		305,
		0,
		136
	],
	"./FireWisePart15.js": [
		305,
		0,
		136
	],
	"./FireWisePart16": [
		306,
		97
	],
	"./FireWisePart16.js": [
		306,
		97
	],
	"./FireWisePart17": [
		307,
		98
	],
	"./FireWisePart17.js": [
		307,
		98
	],
	"./FireWisePart18": [
		308,
		99
	],
	"./FireWisePart18.js": [
		308,
		99
	],
	"./FireWisePart19": [
		309,
		100
	],
	"./FireWisePart19.js": [
		309,
		100
	],
	"./FireWisePart2": [
		310,
		0,
		134
	],
	"./FireWisePart2.js": [
		310,
		0,
		134
	],
	"./FireWisePart3": [
		311,
		0,
		135
	],
	"./FireWisePart3.js": [
		311,
		0,
		135
	],
	"./FireWisePart4": [
		364,
		101
	],
	"./FireWisePart4.js": [
		364,
		101
	],
	"./FireWisePart6": [
		393,
		102
	],
	"./FireWisePart6.js": [
		393,
		102
	],
	"./FireWisePart7": [
		394,
		103
	],
	"./FireWisePart7.js": [
		394,
		103
	],
	"./FireWisePart8": [
		395,
		104
	],
	"./FireWisePart8.js": [
		395,
		104
	],
	"./FireWisePart9": [
		396,
		105
	],
	"./FireWisePart9.js": [
		396,
		105
	],
	"./FloodRiskManagementTips": [
		312,
		106
	],
	"./FloodRiskManagementTips.js": [
		312,
		106
	],
	"./GeneralConditionsAndProvisions": [
		313,
		107
	],
	"./GeneralConditionsAndProvisions.js": [
		313,
		107
	],
	"./GeneratorPart2": [
		314,
		2
	],
	"./GeneratorPart2.js": [
		314,
		2
	],
	"./GeneratorPart3": [
		315,
		3
	],
	"./GeneratorPart3.js": [
		315,
		3
	],
	"./GeneratorPart4": [
		397,
		19
	],
	"./GeneratorPart4.js": [
		397,
		19
	],
	"./Generators": [
		398,
		20
	],
	"./Generators.js": [
		398,
		20
	],
	"./GeneratorsAndSolarSystems": [
		399,
		108
	],
	"./GeneratorsAndSolarSystems.js": [
		399,
		108
	],
	"./GuidelinesToProtectingYourVacantProperty": [
		316,
		109
	],
	"./GuidelinesToProtectingYourVacantProperty.js": [
		316,
		109
	],
	"./HeavyRainAndFlooding": [
		400,
		9
	],
	"./HeavyRainAndFlooding.js": [
		400,
		9
	],
	"./KZNFlooding": [
		401,
		21
	],
	"./KZNFlooding.js": [
		401,
		21
	],
	"./KeyInformationDocuments": [
		317,
		110
	],
	"./KeyInformationDocuments.js": [
		317,
		110
	],
	"./LayoutOfCiaWording": [
		318,
		111
	],
	"./LayoutOfCiaWording.js": [
		318,
		111
	],
	"./LegislativeRequirementsForCommunitySchemesPart1": [
		319,
		112
	],
	"./LegislativeRequirementsForCommunitySchemesPart1.js": [
		319,
		112
	],
	"./LegislativeRequirementsForCommunitySchemesPart2": [
		320,
		113
	],
	"./LegislativeRequirementsForCommunitySchemesPart2.js": [
		320,
		113
	],
	"./LetsPlayActivityBook": [
		321,
		114
	],
	"./LetsPlayActivityBook.js": [
		321,
		114
	],
	"./LiabilityClaimsMadeVsLossesOccurring": [
		322,
		115
	],
	"./LiabilityClaimsMadeVsLossesOccurring.js": [
		322,
		115
	],
	"./LithiumBatteryFiresPart2": [
		323,
		116
	],
	"./LithiumBatteryFiresPart2.js": [
		323,
		116
	],
	"./LithiumBetteryFires": [
		365,
		117
	],
	"./LithiumBetteryFires.js": [
		365,
		117
	],
	"./LoavesForMandelaDayUpdate": [
		402,
		118
	],
	"./LoavesForMandelaDayUpdate.js": [
		402,
		118
	],
	"./MachineryBreakdown": [
		324,
		119
	],
	"./MachineryBreakdown.js": [
		324,
		119
	],
	"./MessageFromSasriasManagingDirector": [
		325,
		4
	],
	"./MessageFromSasriasManagingDirector.js": [
		325,
		4
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy": [
		326,
		120
	],
	"./MotorInclusionInCommunityLivingInsurancePolicy.js": [
		326,
		120
	],
	"./NewCpdApprovedTraining": [
		327,
		121
	],
	"./NewCpdApprovedTraining.js": [
		327,
		121
	],
	"./NewsletterSubscriberPOPIACompliance": [
		328,
		22
	],
	"./NewsletterSubscriberPOPIACompliance.js": [
		328,
		22
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers": [
		329,
		122
	],
	"./OptionalExtraCoverAndSpecificExclusionsForGeysers.js": [
		329,
		122
	],
	"./OvercrowdingPart1": [
		403,
		23
	],
	"./OvercrowdingPart1.js": [
		403,
		23
	],
	"./OvercrowdingPart2": [
		404,
		24
	],
	"./OvercrowdingPart2.js": [
		404,
		24
	],
	"./PersonalAccident": [
		330,
		123
	],
	"./PersonalAccident.js": [
		330,
		123
	],
	"./ProtectingVacantPropertyPart1": [
		331,
		124
	],
	"./ProtectingVacantPropertyPart1.js": [
		331,
		124
	],
	"./ProtectingVacantPropertyPart3": [
		332,
		125
	],
	"./ProtectingVacantPropertyPart3.js": [
		332,
		125
	],
	"./ProtectingVacantPropertyPart4": [
		333,
		126
	],
	"./ProtectingVacantPropertyPart4.js": [
		333,
		126
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance": [
		334,
		127
	],
	"./RenovationsAndHomeImprovementsImpactOnBuildingInsurance.js": [
		334,
		127
	],
	"./RisingDamp": [
		335,
		56
	],
	"./RisingDamp.js": [
		335,
		56
	],
	"./RisingDampPart2": [
		336,
		57
	],
	"./RisingDampPart2.js": [
		336,
		57
	],
	"./SadNewsFromCIA": [
		405,
		25
	],
	"./SadNewsFromCIA.js": [
		405,
		25
	],
	"./SasriaClaims": [
		406,
		26
	],
	"./SasriaClaims.js": [
		406,
		26
	],
	"./SasriaRateIncrease1January2022": [
		337,
		5
	],
	"./SasriaRateIncrease1January2022.js": [
		337,
		5
	],
	"./SasriaRateIncrease2025": [
		407,
		1
	],
	"./SasriaRateIncrease2025.js": [
		407,
		1
	],
	"./SasriaWrapCoverAndWordingChanges": [
		360,
		128
	],
	"./SasriaWrapCoverAndWordingChanges.js": [
		360,
		128
	],
	"./The10YearPlanPart1": [
		408,
		27
	],
	"./The10YearPlanPart1.js": [
		408,
		27
	],
	"./The10YearPlanPart2": [
		338,
		28
	],
	"./The10YearPlanPart2.js": [
		338,
		28
	],
	"./The10YearPlanPart3": [
		366,
		29
	],
	"./The10YearPlanPart3.js": [
		366,
		29
	],
	"./The10YearPlanPart4": [
		409,
		30
	],
	"./The10YearPlanPart4.js": [
		409,
		30
	],
	"./TheDevastationOfLithium": [
		358,
		129
	],
	"./TheDevastationOfLithium.js": [
		358,
		129
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies": [
		339,
		130
	],
	"./TheSimpleLayoutAndLanguageOfCiaPolicies.js": [
		339,
		130
	],
	"./TheftAndCrimeRiskManagement": [
		340,
		131
	],
	"./TheftAndCrimeRiskManagement.js": [
		340,
		131
	],
	"./TrusteesIndemnity": [
		341,
		31
	],
	"./TrusteesIndemnity.js": [
		341,
		31
	],
	"./UnderstandingLiabilityClaimsPart1": [
		410,
		10
	],
	"./UnderstandingLiabilityClaimsPart1.js": [
		410,
		10
	],
	"./UnderstandingLiabilityClaimsPart2": [
		411,
		132
	],
	"./UnderstandingLiabilityClaimsPart2.js": [
		411,
		132
	],
	"./UnderstandingLiabilityClaimsPart3": [
		412,
		11
	],
	"./UnderstandingLiabilityClaimsPart3.js": [
		412,
		11
	],
	"./UnderstandingLiabilityClaimsPart4": [
		413,
		12
	],
	"./UnderstandingLiabilityClaimsPart4.js": [
		413,
		12
	],
	"./UnderstandingLiabilityClaimsPart5": [
		414,
		13
	],
	"./UnderstandingLiabilityClaimsPart5.js": [
		414,
		13
	],
	"./ValidityOfClaims": [
		342,
		32
	],
	"./ValidityOfClaims.js": [
		342,
		32
	],
	"./ValidityOfClaimsPart2": [
		343,
		33
	],
	"./ValidityOfClaimsPart2.js": [
		343,
		33
	],
	"./WaterLeakageTips": [
		344,
		34
	],
	"./WaterLeakageTips.js": [
		344,
		34
	],
	"./WaterproofingAndWaterIngressPart1": [
		415,
		35
	],
	"./WaterproofingAndWaterIngressPart1.js": [
		415,
		35
	],
	"./WaterproofingAndWaterIngressPart2": [
		416,
		36
	],
	"./WaterproofingAndWaterIngressPart2.js": [
		416,
		36
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy": [
		345,
		37
	],
	"./WhatAmICoveredForWithABuildingInsurancePolicy.js": [
		345,
		37
	],
	"./WhatAreGeysersCoveredFor": [
		346,
		38
	],
	"./WhatAreGeysersCoveredFor.js": [
		346,
		38
	],
	"./WhatConstitutesAVoluntaryWorker": [
		347,
		39
	],
	"./WhatConstitutesAVoluntaryWorker.js": [
		347,
		39
	],
	"./WhatDamageRiskManagement": [
		348,
		40
	],
	"./WhatDamageRiskManagement.js": [
		348,
		40
	],
	"./WhatIsASpecificExclusion": [
		349,
		41
	],
	"./WhatIsASpecificExclusion.js": [
		349,
		41
	],
	"./WhatIsCoveredUnderExtraCover": [
		350,
		42
	],
	"./WhatIsCoveredUnderExtraCover.js": [
		350,
		42
	],
	"./WhatIsCoveredUnderTheLiabilitySection": [
		351,
		43
	],
	"./WhatIsCoveredUnderTheLiabilitySection.js": [
		351,
		43
	],
	"./WhatIsExtraCoverFollowingDamage": [
		352,
		44
	],
	"./WhatIsExtraCoverFollowingDamage.js": [
		352,
		44
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover": [
		353,
		45
	],
	"./WhatIsTheDifferenceBetweenAllRisksCoverAndPerilsBasedCover.js": [
		353,
		45
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys": [
		354,
		46
	],
	"./WhatIsThePurposeOfCIARiskManagementSurveys.js": [
		354,
		46
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery": [
		355,
		47
	],
	"./WhatItemsMustBeSpecifiedUnderMachinery.js": [
		355,
		47
	],
	"./WhenIsALossadjusterAppointed": [
		356,
		48
	],
	"./WhenIsALossadjusterAppointed.js": [
		356,
		48
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires": [
		357,
		133
	],
	"./WhyRegularFireExtinguishersWontStopLithiumBatteryFires.js": [
		357,
		133
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 256;
module.exports = webpackAsyncContext;